// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-carousel__arrow i{cursor:pointer;font-size:20pt;font-weight:700}@media (min-width:768px){.el-carousel__container{height:574px}}@media (min-width:768px) and (max-width:1365px){.el-carousel__container{height:535px}}@media (max-width:767px){.el-carousel__container{height:40vh}}.el-carousel__indicators.el-carousel__indicators--horizontal{width:100vw;text-align:center;left:unset;transform:unset}", ""]);
// Exports
module.exports = exports;
